import { Navigate, Outlet } from 'react-router-dom';

export default function ProtectedRoute() {
  const token = localStorage.getItem('token');

  // Si no hay token, redirige al login de inmediato
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  // Si hay token, permite ver la ruta solicitada
  return <Outlet />;
}